import { Button } from '@utilitywarehouse/hearth-react';
import { useNavigate } from 'react-router-dom';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';
import { paths } from '@constants/paths';

import { useMobileContext } from '../Provider/Context';

interface SaveChangesModalProps {
  onSave: () => void;
}

interface SaveChangesModalUIProps {
  dialogId: DialogID;
  onDontSave: () => void;
  onSave: () => void;
}

const SaveChangesModalUI = ({
  dialogId,
  onDontSave,
  onSave,
}: SaveChangesModalUIProps) => (
  <Dialog
    id={dialogId}
    heading="Save changes?"
    description="Would you like to save the changes you've made to your mobile service?"
    preventDismiss
    hideCloseButton
  >
    <DialogActions>
      <Button
        type="button"
        variant="outline"
        colorScheme="destructive"
        onClick={onDontSave}
      >
        Don't save
      </Button>
      <Button type="button" variant="solid" onClick={onSave}>
        Save
      </Button>
    </DialogActions>
  </Dialog>
);

const SaveChangesModal = ({ onSave }: SaveChangesModalProps) => {
  const navigate = useNavigate();
  const dialog = useDialog(DialogID.SAVE_CHANGES_MOBILE);
  const { discardChanges } = useMobileContext();

  const handleDontSave = () => {
    discardChanges();
    dialog.setOpen(false);
    navigate(paths.bundle);
  };

  const handleSave = () => {
    dialog.setOpen(false);
    onSave();
  };

  return (
    <SaveChangesModalUI
      dialogId={dialog.id}
      onDontSave={handleDontSave}
      onSave={handleSave}
    />
  );
};

export type { SaveChangesModalProps, SaveChangesModalUIProps };

export { SaveChangesModal, SaveChangesModalUI };
